import { forwardRef, useRef } from "react";
import { createUseStyles } from "react-jss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { mergeRefs } from "react-merge-refs";

import Label from "../Label";

const useStyles = createUseStyles({
  input: {
    background: "#252525",
    border: "1px solid #707070",
    "border-radius": 3,
    color: "white",
    "margin-top": 3,
    "font-size": 14,
    padding: [5, 10],
    width: "100%",
    "max-width": 300,
    "box-sizing": "border-box",
    position: "relative",
  },
  svg: {
    position: "absolute",
    right: 5,
    bottom: 3,
    cursor: "pointer",
    color: "white",
    padding: 5,
  },
});

const TextInput = forwardRef(
  (
    {
      label,
      required,
      optional,
      onChange,
      value,
      clear,
      clearButton = false,
      ...props
    },
    ref,
  ) => {
    const localRef = useRef();
    const classes = useStyles();
    return (
      <Label name={label} required={required} optional={optional}>
        <input
          ref={mergeRefs([ref, localRef])}
          type="text"
          className={classes.input}
          value={value ?? ""}
          onChange={evt => onChange(evt.target.value)}
          {...props}
        />
        {clearButton && (
          <FontAwesomeIcon
            className={classes.svg}
            icon={("fal", "times-circle")}
            onClick={evt => {
              evt.stopPropagation();
              evt.preventDefault();
              clear ? clear() : onChange("");
              localRef.current.blur();
            }}
          />
        )}
      </Label>
    );
  },
);

export default TextInput;
